import {
  OrganisationIdAndName,
  OrganisationIdAndNameOnly,
} from '@/types/organisation';

export const organisationIdAndNameOnly = (
  organisation: OrganisationIdAndName,
): OrganisationIdAndNameOnly => ({
  id: organisation.id,
  name: organisation.name,
});
